<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Порт</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/images/port1.jpg" width="150" height="106" /> <img src="//iwstatic.g.bsrv.su/resources/images/port5.jpg" width="150" height="106" />
		</p>
		<p><b>Порт</b> - строение, в котором создаются, ремонтируются корабли. Максимальное количество уровней - 10.</p>
		<p><b>Особенности строения:</b></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisPort',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>